import React from 'react';
import { FlagFI } from '../navigation/LanguageFlags';

/**
 * Morphing globe <-> Finnish flag icon for a `FilterSwitch` thumb, used by any Finland-scoped
 * on/off toggle (the global "Show jobs in Finland only" toggle in FilterBuildingBlocks.tsx, and
 * LocationHierarchyPicker's "Show locations outside Finland" toggle). `finlandActive` is true
 * when the toggle's current state means "Finland", not "world" - callers whose `checked` means
 * the opposite (e.g. "show beyond Finland") should pass `!checked`.
 */
export const FinlandGlobeFlagThumb: React.FC<{ finlandActive: boolean }> = ({ finlandActive }) => (
  <span className="relative h-full w-full overflow-hidden rounded-full">
    {/* Colored Earth icon - shown when Finland is not the active mode */}
    <svg
      className={`
        absolute w-full h-full transition-[opacity,transform] duration-300 ease-in-out
        ${finlandActive
          ? 'opacity-0 scale-75 rotate-90'
          : 'opacity-100 scale-100 rotate-0'
        }
      `}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Earth, jc-toned (no generic blue/green) */}
      <circle cx="12" cy="12" r="10" fill="#C8DDCE" stroke="#3B5E45" strokeWidth="0.5"/>
      <path d="M8 10 Q10 8 12 9 Q14 8 16 10 Q15 12 14 13 Q12 14 10 13 Q9 12 8 10 Z" fill="#3B5E45" opacity="0.85"/>
      <path d="M6 14 Q8 12 10 13 Q9 15 7 16 Q6 15 6 14 Z" fill="#3B5E45" opacity="0.85"/>
      <path d="M14 13 Q16 12 18 14 Q17 16 15 17 Q14 16 14 13 Z" fill="#3B5E45" opacity="0.85"/>
      <path d="M10 6 Q12 5 14 6 Q13 8 11 9 Q10 8 10 6 Z" fill="#5A8A68" opacity="0.8"/>
      <path d="M16 6 Q18 5 20 7 Q19 9 17 10 Q16 9 16 6 Z" fill="#5A8A68" opacity="0.8"/>
    </svg>
    {/* Finnish flag - shown when Finland is the active mode (shared FlagFI icon, kept in sync with the language selector) */}
    <span
      className={`
        absolute w-full h-full transition-[opacity,transform] duration-300 ease-in-out
        ${finlandActive
          ? 'opacity-100 scale-100 rotate-0'
          : 'opacity-0 scale-75 -rotate-90'
        }
      `}
    >
      <FlagFI />
    </span>
  </span>
);
